import React, { createRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import MainWrapper from "./wrappers/MainWrapper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { reduxForm, Field, reset, formReducer } from "redux-form";
import validateEmail from "../utils/validateEmail";
import { fetchAllCompany, fetchNewForm, upload, submitForm } from "../actions";
import Snackbar from "@material-ui/core/Snackbar";
import NotificationSnackBar from "../utils/NotificationSnackBar";
import PlusCircleIcon from "@material-ui/icons/AddCircle";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import EnhancedTableToolbar from "../utils/EnhancedTableToolbar";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Typography from "@material-ui/core/Typography";
import CustomTextField from "../components/fields/CustomTextField";
import ReactUploadFile from "react-upload-file";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import MenuItem from "@material-ui/core/MenuItem";
import Dropzone from "react-dropzone";
import request from "superagent";
import Imagee from "./Imagee";
import Chip from "@material-ui/core/Chip";
import FaceIcon from "@material-ui/icons/Face";
import {
  GridListTile,
  GridList,
  ListSubheader,
  GridListTileBar,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReCAPTCHA from "react-google-recaptcha";

import CompanyListTable from "../utils/MainTable/CompanyListTable";

function getModalStyle() {
  return {
    top: `${50}%`,
    left: `${50}%`,
    transform: `translate(-${50}%, -${50}%)`,
  };
}

function urltoFile(url, filename, mimeType) {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
}

function dataURLtoFile(dataurl, filename) {
  console.log(dataurl);
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

const required_fields = [
  { name: "officer1", label: "" },
  { name: "estateName", label: "Estate Name" },
  { name: "certificationStatus", label: "Certification Status" },
  { name: "actualHotspotCoord", label: "Actual Coordinate" },
  { name: "soilType", label: "Soil Type" },
  { name: "vegetationCover", label: "Vegetation" },
];

const chipStyle = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
});

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: "auto",
    marginRight: "auto",
    width: 350,
    fontSize: "3em",
    minHeight: 60,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
});

const WAIT_INTERVAL = 1000;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  loadingHeight: {
    height: "100%",
    position: "fixed",
    top: "0",
    right: "0",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: 350,
  },
  button: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10,
  },
  alreadySignIn: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
  },
  success: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
    color: "green",
  },
});

var soil = [
  {
    text: "Peat",
    value: "Peat",
  },
  {
    text: "Mineral",
    value: "Mineral",
  },

  {
    text: "Sandy",
    value: "Sandy",
  },

  {
    text: "Others",
    value: "Others",
  },
];

var landCoverType = [
  {
    text: "Oil Palm",
    value: "Oil Palm",
  },
  {
    text: "Natural Forest",
    value: "Natural Forest",
  },

  {
    text: "Wood Fibre / Forest Plantation",
    value: "Wood Fibre or Forest Plantation",
  },
  {
    text: "Others",
    value: "Others",
  },
];

var vege = [
  {
    text: "Established Planting",
    value: "Established Planting",
  },

  {
    text: "New Planting",
    value: "New Planting",
  },
  {
    text: "HCV area",
    value: "HCV",
  },
  {
    text: "Grassland",
    value: "grassland",
  },
  {
    text: "Peatland",
    value: "Peatland",
  },
  {
    text: "Scrub",
    value: "Scrub",
  },
  {
    text: "Bare soil",
    value: "Bare soil",
  },

  {
    text: "Others",
    value: "Others",
  },
];

var certStat = [
  {
    text: "Yes",
    value: "Y",
  },
  {
    text: "No",
    value: "N",
  },
];

var fireStat = [
  {
    text: "Within management area",
    value: "Within management area",
  },
  {
    text: "Outside management area",
    value: "Outside management area",
  },
  {
    text: "Within and outside management area",
    value: "Within and outside management area",
  },
  {
    text: "No fire",
    value: "No fire",
  },
];

const dropzoneRef = createRef();

class ConcessionForm extends React.Component {
  options = {
    baseUrl: "http://localhost/",
    // query: {
    //   category: '1',
    //   _: Date().getTime()
    // },
    query: (files) => {
      const l = files.length;
      const queryObj = {};
      for (let i = l - 1; i >= 0; --i) {
        queryObj[i] = files[i].name;
      }
      return queryObj;
    },
    // body: {
    //   purpose: 'save'
    // },

    dataType: "json",
    multiple: true,
    numberLimit: 9,
    accept: "image/*",
    withCredentials: false,
    requestHeaders: {
      "User-Agent": "Warrior!",
    },

    didChoose: (files) => {
      console.log(
        "you choose",
        typeof files == "string" ? files : files[0].name
      );
    },
    beforeUpload: (files) => {
      var data = {
        fileArr: {
          base64: [],
          size: [],
          files: files,
          extension: [],
          name: [],
        },
        fid: this.state.encForm,
        referral: this.state.referral,
      };

      this.props.upload(data);
      /* if (typeof files === 'string') return true;
          if (files[0].size < 1024 * 1024 * 20) {
              console.log(files)
            return true;
          }*/

      return true;
    },
    didUpload: (files) => {
      console.log(
        "you just uploaded",
        typeof files === "string" ? files : files[0].name
      );
    },
    uploading: (progress) => {
      console.log("loading...", progress.loaded / progress.total + "%");
    },
    uploadSuccess: (resp) => {
      console.log("upload success!");
    },
    uploadError: (err) => {
      // alert(err.message);
    },
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      captchaValue: null,
      imgArr: [],
      fileArr: [],
      b64Sources: [],
      b64FileSources: [],
      uploadedFile: [],
      uploadedImages: [],
      allBlobsName: [],
      newConcessionForm: {},
      submitFormRes: {},
      monthyear: new Intl.DateTimeFormat("en-US").format(new Date()),
      dateReport: new Intl.DateTimeFormat("en-US").format(new Date()),
      referral: this.getParameterByName("e"),
      reportTitle: "",
      compName: "",
      officer1: "",
      officer2: "",
      officer1Phone: "",
      officer2Phone: "",
      officer1Email: "",
      officer2Email: "",
      officer1Position: "",
      officer2Position: "",
      incidents: 0,
      hotspotId: "",
      verificationDate: new Intl.DateTimeFormat("en-US").format(new Date()),
      subsidiary: "",
      estateName: "",
      block_fieldno: "",
      province: "",
      certificationStatus: "",
      sourceOfData: "",
      givenHotspotCoord: "",
      actualHotspotCoord: "",
      dateOfHotspot: new Intl.DateTimeFormat("en-US").format(new Date()),
      dateOfFireDetected: new Intl.DateTimeFormat("en-US").format(new Date()),
      dateOfFireExtinguished: new Intl.DateTimeFormat("en-US").format(
        new Date()
      ),
      temperature: 0,
      humidity: 0,
      windDirection: 0,
      precipitation: 0,
      soilType: "",
      vegetationCover: "",
      fireLocation: "",
      npp: "",
      totalAreaBurnt: 0,
      repeatFire: "",
      remarks: "",
      reportKeyword: "",
      isProtected: false,
      otherSoilType: "",
      otherVegeType: "",
      otherLandCover: "",
      blobImagesNames: [],
      blobFileNames: [],

      management1: false,
      management2: false,
      management3: false,
      management4: false,
      management5: false,
      management6: false,
      management7: false,
      management8: false,
      management9: false,
      management10: false,
      management11: false,
      othersmanagementaction: "",
      otherscauses: "",
      landCover: "",
      nppAreaOthers: "",
      nppArea1: false,
      nppArea2: false,
      nppArea3: false,
      nppArea4: false,
      nppArea5: false,

      causes1: false,
      causes2: false,
      causes3: false,
      causes4: false,
      causes5: false,
      causes6: false,
      causes7: false,
      causes8: false,
      causes9: false,
      causes10: false,
      loses1: false,
      loses2: false,
      loses3: false,
      loses4: false,
      loses5: false,
      loses6: false,
      encForm: "",
      incident_status: "",
      consent: false,
      isSaveEnabled: true,
      consent: false,

      checkRequired: false,
      checkRequiredMessage: "",
    };

    var enc = this.getParameterByName("f");
    this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
    this.recaptchaRef = React.createRef();
    this.fetchForm(enc);
  }

  handleCaptchaChange(value) {
    this.setState({ captchaValue: value });
  }
  getParameterByName = (name) => {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  componentDidMount() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    this.setState({
      loading: false,
      dateFrom: today,
      dateTo: today,
      retrieveCompstatus: [],
    });
  }

  fetchForm = (enc) => {
    this.props.fetchNewForm(enc);
  };

  handleDateChange = (name) => (event) => {
    this.updateSnackbarStatusFalse();
    console.log(event);
    console.log(name);
    this.setState({ [name]: event, contextChanged: true });
  };

  handleChange = (name) => (event) => {
    if (name === "actualHotspotCoord") {
      if (!parseFloat(event.target.value)) {
        this.setState({
          checkRequired: true,
          checkRequiredMessage:
            "Coordinate has to be in decimals (e.g. 101.123456, 1.123456)",
        });
        return;
      }
    }

    this.updateSnackbarStatusFalse();

    console.log(name, event.target.value);
    this.setState({ [name]: event.target.value, contextChanged: true });
  };

  handleCheckChange = (name) => (event) => {
    this.updateSnackbarStatusFalse();

    this.setState({
      [name]: event.target.checked,
      consentChecked: event.target.checked,
    });
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.isSwitchSnackbarOn === this.state.isSwitchSnackbarOn) {
      this.updateSnackbarStatusFalse();
    }
  }

  handleClose = () => {
    this.setState({ checkRequired: !this.state.checkRequired });
  };
  static getDerivedStateFromProps(props, state) {
    let update = {};
    if (props.newConcessionForm !== state.newConcessionForm) {
      console.log(props.newConcessionForm);
      var t = props.newConcessionForm.getForm;
      update.isSnackbarError = props.newConcessionForm.isSnackbarError;
      update.isSwitchSnackbarOn = props.newConcessionForm.isSwitchSnackbarOn;
      update.snackbarErrorMessage = props.newConcessionForm.ErrorMessage;
      update.hotspotId = t.hotspot_id;
      update.sourceOfData = t.data_source;
      update.encForm = t.encname;
      update.newConcessionForm = props.newConcessionForm;
      update.givenHotspotCoord = t.hotspot_point;
      update.country = t.country;
      update.compName = t.member_name;
      update.reportTitle = t.report_title;
      update.officer1 = t.officer1;

      if (t.officer_names !== null && t.officer_names !== undefined) {
        update.officer1 = t.officer_names[0];
        update.officer1Phone = t.officer_phones[0];
        update.officer1Email = t.officer_emails[0];
        update.officer1Position = t.officer_positions[0];

        if (t.officer_names.length > 1) {
          update.officer2 = t.officer_names[1];
          update.officer2Phone = t.officer_phones[1];
          update.officer2Email = t.officer_emails[1];
          update.officer2Position = t.officer_positions[1];
        }
      }
      update.monthyear = t.report_month_year;
      update.dateReport = t.report_date;

      update.incidents = t.incidents;
      update.verificationDate = t.verification_date;
      update.subsidiary = t.subsidiary;
      update.estateName = t.estate_name;
      update.block_fieldno = t.block_field;
      update.province = t.province_state;
      update.certificationStatus =
        t.area_certified !== undefined ? t.area_certified : "";
      var pt = "" + t.actual_point;
      if (pt.includes("POINT")) {
        pt = pt.replace("POINT ", "");
        pt = pt.replace("(", "");
        pt = pt.replace(")", "");
        pt = pt.replace(" ", ",");
      }

      if (t.actual_point === null) {
        pt = "";
      }

      update.npp = t.npp;
      update.actualHotspotCoord = pt;
      update.dateOfHotspot = t.hotspot_date;
      update.dateOfFireDetected = t.fire_detected_date;
      update.dateOfFireExtinguished = t.fire_extinguished_date;
      update.temperature = t.temperature;
      update.humidity = t.humidity;
      update.windDirection = t.direction;
      update.precipitation = t.precipitation;
      if (soil.includes(t.soil_type)) {
        update.soilType = t.soil_type;
      } else {
        update.soilType = "Others";
        update.otherSoilType = t.soil_type;
      }

      if (vege.includes(t.vegetationCover)) {
        update.vegetationCover = t.vegetation_cover;
      } else {
        update.vegetationCover = "Others";
        update.otherVegeType = t.vegetation_cover;
      }

      if (landCoverType.includes(t.landCover)) {
        update.landCover = t.land_cover;
      } else {
        update.landCover = "Others";
        update.otherLandCover = t.land_cover;
      }

      //update.vegetationCover= t.vegetation_cover;

      fireStat.map((e) => {
        if (e.value === t.fire_location) {
          update.fireLocation = t.fire_location;
        }
      });
      update.isProtected = t.isProtected;
      if (t.npp) update.npp = "True";
      else update.npp = "False";
      update.totalAreaBurnt = t.area_burnt_ha;
      console.log(update.totalAreaBurnt);
      update.repeatFire = t.repeated_fire;
      update.remarks = t.remarks;
      update.reportKeyword = t.report_status;
      if (t.consent !== null && t.consent !== undefined) {
        update.consent = t.consent;
        update.consentChecked = t.consent;
      }
      if (t.management_action !== null && t.management_action !== undefined) {
        console.log("management action", t.management_action);
        t.management_action.map((e) => {
          if (e == "0") {
            update.management1 = true;
          } else if (parseInt(e, 10)) {
            if (e == 1) {
              update.management2 = true;
            }
            if (e == 2) {
              update.management3 = true;
            }
            if (e == 3) {
              update.management4 = true;
            }
            if (e == 4) {
              update.management5 = true;
              console.log("in 4");
            }
            if (e == 5) {
              update.management6 = true;
              console.log("in 5");
            }
            if (e == 6) {
              update.management7 = true;
            }
            if (e == 7) {
              update.management8 = true;
            }
            if (e == 8) {
              update.management9 = true;
            }
            if (e == 9) {
              update.management10 = true;
            }
          } else {
            update.management11 = true;
            update.othersmanagementaction = e; //this.state.othersmanagementaction;
          }
        });
      }

      if (t.cause_of_fire !== null && t.cause_of_fire !== undefined) {
        console.log("cause of fire", t.cause_of_fire);
        t.cause_of_fire.map((e) => {
          if (e == "0") {
            update.causes1 = true;
          } else if (parseInt(e)) {
            if (e == "1") {
              update.causes2 = true;
            }
            if (e == "2") {
              update.causes3 = true;
            }
            if (e == "3") {
              update.causes4 = true;
            }
            if (e == "4") {
              update.causes5 = true;
            }
            if (e == "5") {
              update.causes6 = true;
            }
            if (e == "6") {
              update.causes7 = true;
            }
            if (e == "7") {
              update.causes8 = true;
            }
            if (e == "8") {
              update.causes9 = true;
            }
          } else {
            update.causes10 = true;
            update.otherscauses = e; //this.state.otherscauses;
          }
        });
      }

      if (t.nppType !== null && t.nppType !== undefined) {
        // console.log('cause of fire', t.nppType)
        t.nppType.map((e) => {
          if (e == "0") {
            update.nppArea1 = true;
          } else if (parseInt(e)) {
            if (e == "1") {
              update.nppArea2 = true;
            }
            if (e == "2") {
              update.nppArea3 = true;
            }
            if (e == "3") {
              update.nppArea4 = true;
            }
          } else {
            update.nppArea5 = true;
            update.nppAreaOthers = e; //this.state.otherscauses;
          }
        });
      }
      if (t.blob_extensions !== undefined && t.imagesBlob !== undefined) {
        update.allBlobsName = t.blob_extensions;
        var ret = t.blob_extensions.filter((ext) => {
          return (
            ext.includes(".jpeg") ||
            ext.includes(".jpg") ||
            ext.includes(".png") ||
            ext.includes(".gif") ||
            ext.includes(".bmp")
          );
        });

        var retOnlyDocs = t.blob_extensions.filter((ext) => {
          return ext.includes(".doc") || ext.includes(".docx");
        });

        var retOnlyPdfs = t.blob_extensions.filter((ext) => {
          return ext.includes(".pdf");
        });

        var onlyImagesB64Str = ret.map((x) => {
          return (
            "data:image/png;base64," +
            t.imagesBlob[t.blob_extensions.indexOf(x)]
          );
        });

        var onlyDocFilesB64Str = retOnlyDocs.map((x) => {
          return (
            "data:application/msword;base64," +
            t.imagesBlob[t.blob_extensions.indexOf(x)]
          );
        });

        var onlyDocPdfB64Str = retOnlyPdfs.map((x) => {
          return (
            "data:application/pdf;base64," +
            t.imagesBlob[t.blob_extensions.indexOf(x)]
          );
        });

        var blobImagesNames = ret.map((x) => {
          return t.blob_extensions.indexOf(x);
        });

        var blobDocFiles = retOnlyDocs.map((x) => {
          return t.blob_extensions.indexOf(x);
        });

        var blobPdfFiles = retOnlyPdfs.map((x) => {
          return t.blob_extensions.indexOf(x);
        });

        var resImagesBlobs = ret.map((x) => {
          console.log("download image name", x);
          var blob = new File([t.imagesBlob[t.blob_extensions.indexOf(x)]], x); // new Blob([ t.imagesBlob[t.blob_extensions.indexOf(x)]], { type: 'images/png;charset=utf-8' });

          console.log("download image  ", blob);
          return blob;
        });

        var resDocFileBlobs = retOnlyDocs.map((x) => {
          var blob = new File([t.imagesBlob[t.blob_extensions.indexOf(x)]], x); // new Blob([ t.imagesBlob[t.blob_extensions.indexOf(x)]], { type: 'images/png;charset=utf-8' });

          return blob;
        });

        var resPdfFileBlobs = retOnlyPdfs.map((x) => {
          var blob = new File([t.imagesBlob[t.blob_extensions.indexOf(x)]], x); // new Blob([ t.imagesBlob[t.blob_extensions.indexOf(x)]], { type: 'images/png;charset=utf-8' });

          return blob;
        });

        var onlyFilesB64Str = [...onlyDocFilesB64Str, ...onlyDocPdfB64Str];
        var blobFilesNames = [...blobDocFiles, ...blobPdfFiles];
        var resFileBlobs = [...resDocFileBlobs, ...resPdfFileBlobs];

        update.blobImagesNames = blobImagesNames;
        update.blobFileNames = blobFilesNames;

        update.b64Sources = onlyImagesB64Str;
        update.b64FileSources = onlyFilesB64Str;
        update.uploadedImages = resImagesBlobs;
        update.uploadedFile = resFileBlobs;
        console.log("resFileBlobs", resFileBlobs);
        console.log(update.uploadedImages);
        console.log(update.uploadedFile);
      }

      // t.incident_status;
    }
    /*
        if(props.newConcessionForm !== state.newConcessionForm){
            console.log(props.newConcessionForm)
            update.isSnackbarError=props.newConcessionForm.isSnackbarError;
            update.isSwitchSnackbarOn=props.newConcessionForm.isSwitchSnackbarOn;
            update.snackbarErrorMessage=props.newConcessionForm.ErrorMessage;
            update.hotspotId = props.newConcessionForm.getForm.hotspot_id;
            update.sourceOfData = props.newConcessionForm.getForm.data_source; 
            update.encForm = props.newConcessionForm.getForm.encname;
            update.newConcessionForm = props.newConcessionForm;
            update.givenHotspotCoord = props.newConcessionForm.getForm.hotspot_point;
            update.compName= props.newConcessionForm.getForm.member_name;
            update.consent = props.newConcessionForm.getForm.consent;
            update.dateOfFireDetected = props.newConcessionForm.getForm.fire_detected_date;
            
            /*if(props.newConcessionForm.getForm.report_status !== 'Uploaded')
                update.isSaveEnabled = true; 
                else
                update.isSaveEnabled  = false
            */
    /*       
        }
    */

    if (props.upload !== state.upload) {
      update.upload = props.upload;
      update.loading = false;
      update.isSnackbarError = props.upload.isSnackbarError;
      update.isSwitchSnackbarOn = props.upload.isSwitchSnackbarOn;
      update.snackbarErrorMessage = props.upload.ErrorMessage;
    }

    if (props.submitFormRes !== state.submitFormRes) {
      update.isSnackbarError = props.submitFormRes.isSnackbarError;
      update.isSwitchSnackbarOn = props.submitFormRes.isSwitchSnackbarOn;
      update.snackbarErrorMessage = props.submitFormRes.ErrorMessage;
      update.submitFormRes = props.submitFormRes;
      console.log(props.submitFormRes);
      if (props.submitFormRes.success) update.isSaveEnabled = false;
    }

    return update;
  }

  updateSnackbarStatus = (snackbarObject) => {
    this.setState({
      isSnackbarError: snackbarObject.isSnackbarError,
      isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
      snackbarErrorMessage: snackbarObject.ErrorMessage,
    });
  };

  updateSnackbarStatusFalse = () => {
    if (this.state.isSwitchSnackbarOn) {
      this.setState({ isSwitchSnackbarOn: false });
    }
  };

  /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
*/
  getBase64(file) {
    console.log(file);
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var c = this.state.b64Sources;
    let that = this;
    reader.onload = function () {
      c.push(reader.result);
      that.setState({
        b64Sources: c,
      });
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  getFileBase64(file) {
    console.log(file);
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var c = this.state.b64FileSources;
    let that = this;
    reader.onload = function () {
      c.push(reader.result);
      that.setState({
        b64FileSources: c,
      });
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  getThumbnail = (data) => {
    let that = this;
    var one = new Promise((resolve, reject) => {
      var sI = data;
      var arr = [];
      var count = 0;
      sI.map((it) => {
        that.getBase64(it, function (response) {
          arr.push(response);
        });
      });

      resolve(arr);
    });

    one.then((res) => {
      that.setState({
        imgArr: res,
      });
      // console.log(res)
    });
  };

  onImageDrop(files) {
    //  this.getThumbnail(files)
    var ar = this.state.uploadedImages;
    files.map((f) => {
      if (
        f.name.includes(".jpg") ||
        f.name.includes(".jpeg") ||
        f.name.includes(".png") ||
        f.name.includes(".bmp")
      ) {
        if (this.state.allBlobsName.includes(f.name)) {
          alert(
            "Similar file names detected. Please ensure different file names uploaded"
          );
          return;
        }

        this.getBase64(f);
        ar.push(f);
      }
    });
    this.setState({
      uploadedImages: ar,
    });
  }

  onImageLoad = (item) => {
    var src = "";
    var a = this.state.b64Sources;
    let that = this;
    this.getBase64(item);
  };

  async onFileDrop(files) {
    console.log("on file drops", files);

    //  this.getThumbnail(files)
    var ar = this.state.uploadedFile;

    var data = await Promise.all(
      files.map((f) => {
        if (
          f.name.includes(".docx") ||
          f.name.includes(".doc") ||
          f.name.includes(".pdf")
        ) {
          if (this.state.allBlobsName.includes(f.name)) {
            alert(
              "Similar file names detected. Please ensure different file names uploaded"
            );
            return;
          }

          console.log(f.name);
          this.getFileBase64(f);
          return f;
        }
      })
    );
    var final = [].concat(ar, data);
    this.setState({
      uploadedFile: final,
    });
  }

  onFileLoad = (item) => {
    var src = "";
    console.log("on file loads");
    var a = this.state.b64FileSources;
    let that = this;
    console.log(item);
    if (
      item.name.includes(".docx") ||
      item.name.includes(".doc") ||
      item.name.includes(".pdf")
    )
      this.getFileBase64(item);
  };

  handleClick = () => {
    console.info("You clicked the Chip.");
  };

  handleDeleteFiles = (id, filename) => {
    var up = this.state.uploadedFile;
    var bb = this.state.b64FileSources;
    var allfilesname = this.state.allBlobsName;
    var ind = allfilesname.indexOf(filename);
    up.splice(id, 1);
    bb.splice(id, 1);
    allfilesname.splice(ind, 1);

    this.setState({
      uploadedFile: up,
      b64FileSources: bb,
      allBlobsName: allfilesname,
    });
  };

  handleDelete = (id, filename) => {
    var up = this.state.uploadedImages;
    var bb = this.state.b64Sources;
    var allfilesname = this.state.allBlobsName;
    var ind = allfilesname.indexOf(filename);
    allfilesname.splice(ind, 1);

    up.splice(id, 1);
    bb.splice(id, 1);

    this.setState({
      uploadedImages: up,
      b64Sources: bb,

      allBlobsName: allfilesname,
    });

    console.log(this.state.allBlobsName);
  };

  handleSubmitForm = () => {
    console.log("in submit form");
    /*

    { name: "officer1", label: "Officer 1" },  
    { name: "estateName", label: "Estate Name" }, 
    { name: "certificationStatus", label: "Certification Status" },
    { name: "actualHotspotCoord", label: "Actual Coordinate" },
    { name: "soilType", label: "Soil Type" },
    { name: "vegetationCover", label: "Vegetation" }, 
    */

    if (!this.state.captchaValue) {
      alert("Please verify that you are not a robot!");
      return;
    }
    if (this.state.officer1 === "" || this.state.officer1 === null) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Officer name field is empty",
      });

      return;
    }

    console.log(this.state.estateName);
    if (this.state.estateName === "" || this.state.estateName === null) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Estate Name field is empty",
      });

      return;
    }

    if (
      this.state.certificationStatus === "" ||
      this.state.certificationStatus === null
    ) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Certification status field is empty",
      });
      return;
    }

    if (
      this.state.actualHotspotCoord === "" ||
      this.state.actualHotspotCoord === null
    ) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Actual Coordinate field is empty",
      });
      return;
    }

    if (this.state.soilType === "" || this.state.soilType === null) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Soil Type field is empty",
      });
      return;
    }

    if (
      this.state.vegetationCover === "" ||
      this.state.vegetationCover === null
    ) {
      this.setState({
        checkRequired: true,
        checkRequiredMessage: "Vegetation Cover field is empty",
      });
      return;
    }

    var officers = [];
    var officersPhone = [];
    var officersEmail = [];
    var officersPositions = [];
    if (this.state.officer1 !== "" && this.state.officer1 !== undefined)
      officers.push(this.state.officer1);
    if (this.state.officer2 !== "" && this.state.officer2 !== undefined)
      officers.push(this.state.officer2);
    if (
      this.state.officer1Phone !== "" &&
      this.state.officer1Phone !== undefined
    )
      officersPhone.push(this.state.officer1Phone);
    if (
      this.state.officer2Phone !== "" &&
      this.state.officer2Phone !== undefined
    )
      officersPhone.push(this.state.officer2Phone);

    if (
      this.state.officer1Email !== "" &&
      this.state.officer1Email !== undefined
    )
      officersEmail.push(this.state.officer1Email);
    if (
      this.state.officer2Email !== "" &&
      this.state.officer2Email !== undefined
    )
      officersEmail.push(this.state.officer2Email);

    if (
      this.state.officer1Position !== "" &&
      this.state.officer1Position !== undefined
    )
      officersPositions.push(this.state.officer1Position);

    if (
      this.state.officer2Position !== "" &&
      this.state.officer2Position !== undefined
    )
      officersPositions.push(this.state.officer2Position);

    var checkedNpp = [];
    if (this.state.nppArea1) checkedNpp.push(0);

    if (this.state.nppArea2) checkedNpp.push(1);

    if (this.state.nppArea3) checkedNpp.push(2);

    if (this.state.nppArea4) checkedNpp.push(3);

    if (this.state.nppArea5) checkedNpp.push(this.state.nppAreaOthers);

    var checkedManagement = [];
    if (this.state.management1) checkedManagement.push(0);

    if (this.state.management2) checkedManagement.push(1);

    if (this.state.management3) checkedManagement.push(2);

    if (this.state.management4) checkedManagement.push(3);

    if (this.state.management5) checkedManagement.push(4);

    if (this.state.management6) checkedManagement.push(5);

    if (this.state.management7) checkedManagement.push(6);

    if (this.state.management8) checkedManagement.push(7);

    if (this.state.management9) checkedManagement.push(8);

    if (this.state.management10) checkedManagement.push(9);

    if (this.state.management11)
      checkedManagement.push(this.state.othersmanagementaction);

    var checkedCauses = [];

    if (this.state.causes1) checkedCauses.push(0);

    if (this.state.causes2) checkedCauses.push(1);

    if (this.state.causes3) checkedCauses.push(2);

    if (this.state.causes4) checkedCauses.push(3);

    if (this.state.causes5) checkedCauses.push(4);

    if (this.state.causes6) checkedCauses.push(5);

    if (this.state.causes7) checkedCauses.push(6);

    if (this.state.causes8) checkedCauses.push(7);

    if (this.state.causes9) checkedCauses.push(8);
    if (this.state.causes10) checkedCauses.push(this.state.otherscauses);

    var actualCord = this.state.actualHotspotCoord.split(",");
    var actualLong = actualCord[0];
    var actualLat = actualCord[1];
    var repeat = false;
    if (this.state.repeatFire === "Yes") {
      repeat = true;
    }

    var nppHere = false;
    if (this.state.npp === "True") {
      nppHere = true;
    }

    console.log("the state", this.state);
    var a = {
      report_month_year: this.state.monthyear,
      compName: this.state.compName,
      report_date: this.state.dateReport,
      report_title: this.state.reportTitle,
      officer_names: officers,
      officer_phones: officersPhone,
      officer_emails: officersEmail,
      officer_positions: officersPositions,
      actual_latitude: actualLat,
      actual_longitude: actualLong,
      incidents: this.state.incidents,
      verification_date: this.state.verificationDate,
      subsidiary: this.state.subsidiary,
      estate_name: this.state.estateName,
      block_field: this.state.block_fieldno,
      province_state: this.state.province,
      area_certified: this.state.certificationStatus,
      hotspot_date: this.state.dateOfHotspot,
      fire_detected_date: this.state.dateOfFireDetected,
      fire_extinguished_date: this.state.dateOfFireExtinguished,
      temperature: this.state.temperature,
      humidity: this.state.humidity,
      direction: this.state.windDirection,

      precipitation: this.state.precipitation,
      soil_type:
        this.state.soilType === "Others"
          ? this.state.otherSoilType
          : this.state.soilType,
      vegetation_cover:
        this.state.vegetationCover === "Others"
          ? this.state.otherVegeType
          : this.state.vegetationCover,
      landCover:
        this.state.landCover === "Others"
          ? this.state.otherLandCover
          : this.state.landCover,
      fire_location: this.state.fireLocation,
      area_burnt_ha: this.state.totalAreaBurnt,
      repeated_fire: repeat,
      remarks: this.state.remarks,
      incident_status: "",
      management_action: checkedManagement,
      cause_of_fire: checkedCauses,
      npp: nppHere,
      nppType: checkedNpp,
      consent: this.state.consent,
    };
    console.log("submit form", a);
    var imgarray = this.state.uploadedImages;
    var filearray = this.state.uploadedFile;
    var b64array = this.state.b64Sources;
    var b64arrayFile = this.state.b64FileSources;
    console.log("filearray", filearray);
    console.log("b64arrayFile", b64arrayFile);
    var imgToPostArray = [];
    var fileToPostArray = [];
    imgarray.map((e) => {
      imgToPostArray.push({
        name: e.name,
        type: e.type,
        size: e.size,
        b64: b64array[imgarray.indexOf(e)],
      });
    });

    filearray.map((e) => {
      fileToPostArray.push({
        name: e.name,
        type: e.type,
        size: e.size,
        b64: b64arrayFile[filearray.indexOf(e)],
      });
    });

    var dat = {
      fId: this.state.encForm,
      form: a,
      images: imgToPostArray,
      files: fileToPostArray,
      referral: this.state.referral,
    };
    console.log("dat form", dat);
    // this.setState({newConcessionForm: a});

    this.recaptchaRef.current.reset();
    this.setState({ captchaValue: null });
    this.props.submitForm(dat);
  };

  handleSearch = (event) => {
    if (this.state.contextChanged) {
      this.setState({ loading: true });
      this.updateSnackbarStatusFalse();
      // this.setState({ searchVal: event.target.value })
      //this.props.fetchAllCompany(this.state.reportKeyword);
    }
  };

  _handleSubmit = (values) => {
    this.updateSnackbarStatusFalse();
    //  this.setState({ loading: true });
  };

  submitNewComp = () => {
    var newReport = {};

    this.setState({ loading: true });
    this.updateSnackbarStatusFalse();
    // this.props.createNewComp(newComp);
  };

  checkChecked = (arr) => {
    return arr.filter((v) => v);
  };

  clickToDownload = (content, filename, type) => {
    var f = dataURLtoFile("data:" + type + ";base64," + content, filename);
    console.log(f);
    /*var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(f, filename);
        } else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(f);
            const a = document.createElement('a');
            a.href = link;
            document.body.appendChild(a);
            a.target='_blank';
            a.click();
            //$("body").append(a);
           // a[0].click();
            document.body.removeChild(link);
           // $("body").remove(a);
        }*/
    //window.open('data:'+type+';base64,'+content, '_target');

    /*const link = document.createElement('a');
        link.download = filename;
        link.href = 'data:'+type+';base64,'+content;

        // Append to the document
        document.body.appendChild(link);

        // Trigger the click event
        link.click();

        // Remove the element
        document.body.removeChild(link);
        */
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="d-flex justify-content-center">
          <CircularProgress color="primary" size={70} thickness={7} />
        </div>
      );
    }
    const { classes } = this.props;
    const {
      isSwitchSnackbarOn,
      isSnackbarError,
      uploadedFile,
      consentChecked,
      checkRequired,
      uploadedImages,
      imgArr,
      b64Sources,
      referral,
      totalAreaBurnt,
      officer1,
      blobImagesNames,
      blobFileNames,
      allBlobsName,
      b64FileSources,
      checkRequiredMessage,
    } = this.state;

    const {
      management1,
      management2,
      management3,
      management4,
      management5,
      management6,
      management7,
      management8,
      management9,
      management10,
      management11,
      causes1,
      causes2,
      causes3,
      causes4,
      causes5,
      causes6,
      causes7,
      causes8,
      causes9,
      causes10,
      nppArea1,
      nppArea2,
      nppArea3,
      nppArea4,
      nppArea5,
      nppAreaOthers,
      nppType,
      npp,
      loses1,
      loses2,
      loses3,
      loses4,
      loses5,
      loses6,
      consent,
      othersmanagementaction,
      otherscauses,
    } = this.state;
    const errorManagement =
      [
        management1,
        management2,
        management3,
        management4,
        management5,
        management6,
        management7,
        management8,
        management9,
        management10,
        management11,
      ].filter((v) => v).length !== 5;
    const errorCauses =
      [
        causes1,
        causes2,
        causes3,
        causes4,
        causes5,
        causes6,
        causes7,
        causes8,
        causes9,
        causes10,
      ].filter((v) => v).length !== 2;
    const errorLoses =
      [loses1, loses2, loses3, loses4, loses5, loses6].filter((v) => v)
        .length !== 2;
    const errorNPP =
      [nppArea1, nppArea2, nppArea3, nppArea4, nppArea5].filter((v) => v)
        .length !== 2;

    return (
      <div>
        <div id="google_translate_element"></div>

        <form
          className={classes.container}
          onSubmit={this.props.handleSubmit(this.handleSubmitForm)}
        >
          <Paper
            style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }}
          >
            <Grid container style={{ padding: "10px", width: "100%" }}>
              <Grid container style={{ padding: "10px", width: "100%" }}>
                <Grid item xs={6}>
                  <Typography variant="h4" gutterBottom>
                    RSPO Internal Hotspot &amp; Fire Monitoring
                  </Typography>
                </Grid>
              </Grid>
              <Grid container style={{ padding: "10px", width: "100%" }}>
                <Grid item xs={6} style={{ align: "center" }}>
                  <Typography variant="h4" gutterBottom>
                    Form ID: <span id="encFormID">{this.state.encForm}</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item>
                  <span>Fire Report Form</span>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item>
                  <span>
                    This document is prepared as guidance for RSPO members to
                    fill in and submit the internal hotspot and fire monitoring
                    e-form to the RSPO Secretariat. <br />
                    <br />
                    This document is to be completed by RSPO members who own or
                    manage oil palm plantations and/or mills to fill in and
                    submit to the RSPO Secretariat, when hotspots are identified
                    by the RSPO Secretariat as potential fire hotspots which may
                    or may not include fire incidents. In the absence of fire or
                    if fire incidents occur outside of your concession, kindly
                    report back the actual coordinate and your efforts to manage
                    the situation. The presence of hotspots may be notified to
                    RSPO grower members through (1) Global Forest Watch (GFW)
                    fire alert, (2) from RSPO's internal monitoring, or (3)
                    companies' own internal monitoring.
                  </span>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item>
                  <span>
                    <br />
                    Kindly complete and return this form to firewatch@rspo.org
                    within 5 working days.
                  </span>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Consent
                </Grid>
                <Grid item>
                  <FormControl
                    error={errorLoses}
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={consent}
                            id="consentCheck"
                            onChange={this.handleCheckChange("consent")}
                            value="consent"
                          />
                        }
                        label={
                          <div>
                            <Typography display="block">
                              Selected:{" "}
                              <span id="consentSelected">
                                {consentChecked ? "Yes" : "No"}
                              </span>
                            </Typography>
                            <Typography display="block">
                              Please indicate your consent for RSPO Secretariat
                              to publish all or any part of this report for the
                              purpose of promoting grower members' commitment to
                              the public with regards to wildfire mitigation and
                              prevention.
                            </Typography>
                          </div>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Hotspot ID (if alert was received from RSPO’s internal
                  monitoring)
                </Grid>
                <Grid item>
                  <TextField
                    id="hotspotID"
                    name="hotspotId"
                    placeholder="Hotspot ID"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    value={this.state.hotspotId}
                    disabled
                    onChange={this.handleChange("hotspotId")}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Hotspot detection date
                </Grid>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MMM/yyyy"
                      margin="normal"
                      id="hotspotDetectedDate"
                      label={
                        this.state.dateOfFireDetected !== null
                          ? this.state.dateOfFireDetected
                          : "Date of fire detected"
                      }
                      disabled
                      value={this.state.dateOfFireDetected}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Date of field verification (dd/mm/yyyy)
                </Grid>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MMM/yyyy"
                      margin="normal"
                      id="dateOfFieldVerification"
                      label="Date of field verification"
                      value={this.state.verificationDate}
                      onChange={this.handleDateChange("verificationDate")}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Date of fire extinguished (dd/mmm/yyyy)
                </Grid>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MMM/yyyy"
                      margin="normal"
                      id="dateOfFireExtinguised"
                      label="Date of fire extinguished"
                      value={this.state.dateOfFireExtinguished}
                      onChange={this.handleDateChange("dateOfFireExtinguished")}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Date of Report
                </Grid>

                <Grid item style={{ padding: "10px" }} xl={6}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MMM/yyyy"
                      margin="normal"
                      id="dateOfReport"
                      label="Date of Report"
                      value={this.state.dateReport}
                      onChange={this.handleDateChange("dateReport")}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  RSPO member name (company name)
                </Grid>

                <Grid item style={{ padding: "10px" }} xl={6}>
                  <TextField
                    id="compName"
                    placeholder="Company Name"
                    value={this.state.compName}
                    disabled
                    onChange={this.handleChange("compName")}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Subsidiary
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="subsidiaryTxt"
                    label="Subsidiary"
                    name="subsidiary"
                    placeholder="Placeholder"
                    className={classes.textField}
                    margin="normal"
                    disabled
                    variant="outlined"
                    onChange={this.handleChange("subsidiary")}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Estate name
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="estateNameTxt"
                    label={this.state.estateName !== "" ? "" : "Estate name"}
                    name="estateName"
                    placeholder="Placeholder"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("estateName")}
                    InputValue={this.state.estateName}
                    initialValues={this.state.estateName}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Block/Field No
                </Grid>
                <Grid item>
                  <Field
                    id="block_fieldnoTxt"
                    label="Block/Field No"
                    placeholder="Placeholder"
                    name="block_fieldno"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("block_fieldno")}
                    component={CustomTextField}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  State / Province
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="provinceTxt"
                    label={this.state.province !== "" ? "" : "Province/State"}
                    placeholder="Placeholder"
                    name="province"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("province")}
                    InputValue={this.state.province}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Country
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <CustomTextField
                      id="countryTxt"
                      placeholder=""
                      name="country"
                      className={classes.textField}
                      margin="normal"
                      variant="outlined"
                      InputValue={this.state.country}
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Officer in Charge (E.g. Sustainability/Safety Manager)
                  <br /> (Use comma for more than (1) officer)
                </Grid>

                <Grid item style={{ padding: "10px" }} xl={6}>
                  <Grid container>
                    <Grid item>
                      <CustomTextField
                        id="officer1"
                        name="officer1"
                        label={
                          this.state.officer1Email !== "" &&
                          this.state.officer1Email !== null
                            ? ""
                            : "Officer Name"
                        }
                        onChange={this.handleChange("officer1")}
                        // component={CustomTextField}
                        InputValue={this.state.officer1}
                        initialValues={this.state.officer1}
                      />
                    </Grid>
                    <Grid item>
                      <CustomTextField
                        id="officer1Email"
                        name="officer1Email"
                        label={
                          this.state.officer1Email !== "" &&
                          this.state.officer1Email !== null
                            ? ""
                            : "Officer Email"
                        }
                        onChange={this.handleChange("officer1Email")}
                        // component={CustomTextField}
                        InputValue={this.state.officer1Email}
                        initialValues={this.state.officer1Email}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  &nbsp;
                </Grid>

                <Grid item style={{ padding: "10px", display: "none" }} xl={6}>
                  <Grid container>
                    <Grid item>(Officer's name)</Grid>
                    <Grid item>(Officer's email)</Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Email
                </Grid>

                <Grid item style={{ padding: "10px", display: "none" }}>
                  <Grid container>
                    <Grid item>
                      <Field
                        id="officer2Email"
                        name="officer2Email"
                        label="Officer 2 Email"
                        onChange={this.handleChange("officer2Email")}
                        component={CustomTextField}
                        style={{ display: "none" }}
                      />{" "}
                      <Grid item>
                        <Field
                          id="officer1Position"
                          name="officer1Position"
                          label="Officer 1 Position"
                          onChange={this.handleChange("officer1Position")}
                          component={CustomTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container style={{ display: "none" }}>
                    <Grid item>
                      <Field
                        name="officer1Phone"
                        id="officer1Phone"
                        label="Officer 1 Phone"
                        onChange={this.handleChange("officer1Phone")}
                        component={CustomTextField}
                        InputValue={this.state.officer1Phone}
                      />
                    </Grid>
                    <Grid item>
                      <Field
                        id="officer2Phone"
                        name="officer2Phone"
                        label="Officer 2 Phone"
                        onChange={this.handleChange("officer2Phone")}
                        component={CustomTextField}
                        style={{ display: "none" }}
                        InputValue={this.state.officer2Phone}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Certification status of the area (Y = Certified, N = Not
                  certified)
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel
                      shrink
                      htmlFor="certificationStatus-label-placeholder"
                    >
                      Certification
                    </InputLabel>
                    <Select
                      value={this.state.certificationStatus}
                      onChange={this.handleChange("certificationStatus")}
                      inputProps={{
                        name: "certificationStatus",
                        id: "certificationStatus-label-placeholder",
                      }}
                      name="certificationStatus"
                      id="certificationStatusSelect"
                      className={classes.selectEmpty}
                    >
                      {certStat.map((ei) => (
                        <MenuItem value={"" + ei.value} key={ei.value}>
                          {ei.text}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>Certification</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Source of data (NASA, GFW, RSPO etc.)
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="dataSource"
                    placeholder="Source of Data"
                    name="sourceOfData"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    InputValue={this.state.sourceOfData}
                    disabled
                    onChange={this.handleChange("sourceOfData")}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Detected hotspot coordinates
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="givenHotspot"
                    className={classes.textField}
                    margin="normal"
                    name="givenHotspotCoord"
                    variant="outlined"
                    disabled
                    InputValue={this.state.givenHotspotCoord}
                    onChange={this.handleChange("givenHotspotCoord")}
                    //     component={CustomTextField}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Actual fire coordinates on the ground (decimal degree format
                  and in digits only) - no space in between
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="actualHsCoordinate"
                    placeholder="eg: 101.211,2.122"
                    name="actualHotspotCoord"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("actualHotspotCoord")}
                    //     component={CustomTextField}
                    InputValue={this.state.actualHotspotCoord}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Date of hotspot (dd/mmm/yyyy)
                </Grid>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MMM/yyyy"
                      margin="normal"
                      id="dateOfHotspotTxt"
                      label="Date of hotspot"
                      value={this.state.dateOfHotspot}
                      onChange={this.handleDateChange("dateOfHotspot")}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  <br />
                  Protected (Area) source:
                </Grid>
                <Grid item>
                  <br />
                  (This section indicates whether the area is a protected area,
                  based on the June 2021 World Database on Protected Areas
                  (WDPA) data acquired from Protected Planet)
                  <br />
                  <br /> This item is fixed and cannot be edited.
                  <br />
                  <FormControl className={classes.formControl}>
                    <CustomTextField
                      id="protectedTxt"
                      placeholder=""
                      name="isProtected"
                      className={classes.textField}
                      margin="normal"
                      variant="outlined"
                      InputValue={this.state.isProtected ? "Yes" : "No"}
                      disabled
                      //    component={CustomTextField}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  New Planting Procedure (NPP) Status / Assessment
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="nppType-label-placeholder">
                      NPP
                    </InputLabel>
                    <Select
                      value={npp}
                      onChange={this.handleChange("npp")}
                      inputProps={{
                        name: "npp",
                        id: "nppType-label-placeholder",
                      }}
                      id="nppSelect"
                      name="npp"
                      className={classes.selectEmpty}
                    >
                      <MenuItem value={"True"} key={"Yes"}>
                        Yes
                      </MenuItem>
                      <MenuItem value={"False"} key={"No"}>
                        No
                      </MenuItem>
                    </Select>
                    <FormHelperText>NPP</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Affected NPP Area
                </Grid>
                <Grid item>
                  <FormControl
                    error={errorNPP}
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={npp !== "True"}
                            checked={nppArea1}
                            onChange={this.handleCheckChange("nppArea1")}
                            value="nppArea1"
                            id="nppArea1"
                          />
                        }
                        label="HCV"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={npp !== "True"}
                            checked={nppArea2}
                            onChange={this.handleCheckChange("nppArea2")}
                            value="nppArea2"
                            id="nppArea2"
                          />
                        }
                        label="HCS"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={npp !== "True"}
                            checked={nppArea3}
                            onChange={this.handleCheckChange("nppArea3")}
                            value="nppArea3"
                            id="nppArea3"
                          />
                        }
                        label="HCVMA"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={npp !== "True"}
                            checked={nppArea4}
                            onChange={this.handleCheckChange("nppArea4")}
                            value="nppArea4"
                            id="nppArea4"
                          />
                        }
                        label="Proposed Area for new planting"
                      />

                      <FormControlLabel
                        control={
                          <div>
                            <Checkbox
                              checked={nppArea5}
                              onChange={this.handleCheckChange("nppArea5")}
                              value="nppArea5"
                              disabled={npp !== "True"}
                              id="nppArea5"
                            />
                            <TextField
                              id="nppArea5Txt"
                              label="Others"
                              placeholder="Others"
                              name="nppAreaOthers"
                              multiline
                              className={classes.textField}
                              margin="normal"
                              disabled={npp !== "True"}
                              variant="outlined"
                              value={nppAreaOthers}
                              onChange={this.handleChange("nppAreaOthers")}
                            />
                          </div>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Soil type
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="soiltype-label-placeholder">
                      Soil
                    </InputLabel>
                    <Select
                      value={this.state.soilType}
                      onChange={this.handleChange("soilType")}
                      inputProps={{
                        name: "soilType",
                        id: "soilType-label-placeholder",
                      }}
                      id="soilTypeSelect"
                      name="soilType"
                      className={classes.selectEmpty}
                    >
                      {soil.map((ei) => (
                        <MenuItem value={"" + ei.value} key={ei.value}>
                          {ei.text}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                    {this.state.soilType === "Others" ? (
                      <CustomTextField
                        id="otherSoilTypeTxt"
                        placeholder="Others.."
                        name="othersSoilType"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        InputValue={this.state.otherSoilType}
                        onChange={this.handleChange("otherSoilType")}
                        //  component={CustomTextField}
                      />
                    ) : null}
                    <FormHelperText>Soil Type</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Land Use Type
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="landCover-label-placeholder">
                      Land Use
                    </InputLabel>
                    <Select
                      value={this.state.landCover}
                      onChange={this.handleChange("landCover")}
                      inputProps={{
                        name: "landCover",
                        id: "landCover-label-placeholder",
                      }}
                      id="landCoverTypeSelect"
                      name="landCover"
                      className={classes.selectEmpty}
                    >
                      {landCoverType.map((ei) => (
                        <MenuItem value={"" + ei.value} key={ei.value}>
                          {ei.text}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                    {this.state.landCover === "Others" ? (
                      <CustomTextField
                        id="otherLandCoverTxt"
                        placeholder="Others.."
                        name="otherLandCover"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        InputValue={this.state.otherLandCover}
                        onChange={this.handleChange("otherLandCover")}
                        component={CustomTextField}
                      />
                    ) : null}
                    <FormHelperText>Land Use Type</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Land Cover Type <br />
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel
                      shrink
                      htmlFor="vegetationCover-label-placeholder"
                    >
                      Land Cover Type
                    </InputLabel>
                    <Select
                      value={this.state.vegetationCover}
                      onChange={this.handleChange("vegetationCover")}
                      inputProps={{
                        name: "vegetationCover",
                        id: "vegetationCover-label-placeholder",
                      }}
                      id="vegetationCoverSelect"
                      name="vegetationCover"
                      className={classes.selectEmpty}
                    >
                      {vege.map((ei) => (
                        <MenuItem value={"" + ei.value} key={ei.value}>
                          {ei.text}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                    {this.state.vegetationCover === "Others" ? (
                      <CustomTextField
                        id="otherVegeTypeTxt"
                        placeholder="Others.."
                        name="otherVegeType"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        InputValue={this.state.otherVegeType}
                        onChange={this.handleChange("otherVegeType")}
                        component={CustomTextField}
                      />
                    ) : null}
                    <FormHelperText>Land Cover Type </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Location of fire
                </Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="fireLocation-label-placeholder">
                      Incident Status
                    </InputLabel>
                    <Select
                      value={this.state.fireLocation}
                      onChange={this.handleChange("fireLocation")}
                      inputProps={{
                        name: "fireLocation",
                        id: "fireLocation-label-placeholder",
                      }}
                      id="fireLocationSelect"
                      name="fireLocation"
                      className={classes.selectEmpty}
                    >
                      {fireStat.map((ei) => (
                        <MenuItem value={"" + ei.value} key={ei.value}>
                          {ei.text}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>Incident Status</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Total burnt area in hectares (ha)
                </Grid>
                <Grid item>
                  <CustomTextField
                    id="areaburntTxt"
                    label={parseFloat(totalAreaBurnt) ? "" : ""}
                    placeholder=""
                    name="totalAreaBurnt"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("totalAreaBurnt")}
                    InputValue={totalAreaBurnt}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Management action by Members for fire prevention, fire
                  avoidance, risks of arson on company property
                </Grid>
                <Grid item>
                  <Typography subtitle1>
                    In this section, please select the applicable Management
                    action. Note that the list below is merely a guidance and is
                    non-exhaustive. Members can fill in the last text box
                    (Others) to add more actions
                  </Typography>
                  <FormControl
                    error={errorManagement}
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management1}
                            onChange={this.handleCheckChange("management1")}
                            value="management1"
                            id="manageChk1"
                          />
                        }
                        label="1. Monitoring, patrolling of planted area, recently planted, recently cleared land"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management2}
                            onChange={this.handleCheckChange("management2")}
                            value="management2"
                            id="manageChk2"
                          />
                        }
                        label="2. Full time fire guards on duty throughout the plantation for duration of dry season"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management3}
                            onChange={this.handleCheckChange("management3")}
                            value="management3"
                            id="manageChk3"
                          />
                        }
                        label="3. Prevention of unauthorised individuals into the company property"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management4}
                            onChange={this.handleCheckChange("management4")}
                            value="management4"
                            id="manageChk4"
                          />
                        }
                        label="4. Daily fire report to the Plantation Manager every morning (after muster)"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management5}
                            onChange={this.handleCheckChange("management5")}
                            value="management5"
                            id="manageChk5"
                          />
                        }
                        label="5. Monitoring carried out throughout the time, but more actively at night"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management6}
                            onChange={this.handleCheckChange("management6")}
                            value="management6"
                            id="manageChk6"
                          />
                        }
                        label="6. Preparedness with firefighting facilities on standby during dry season, fire truck, truck mounted water tanks available, etc"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management7}
                            onChange={this.handleCheckChange("management7")}
                            value="management7"
                            id="manageChk7"
                          />
                        }
                        label="7. Monitoring through GFW, NOAA (Singapore NEA) done at plantation level"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management8}
                            onChange={this.handleCheckChange("management8")}
                            value="management8"
                            id="manageChk8"
                          />
                        }
                        label="8. Establishment of fire break (wide road, vacant land) within the planted area"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management9}
                            onChange={this.handleCheckChange("management9")}
                            value="management9"
                            id="manageChk9"
                          />
                        }
                        label="9. Community engagement work where fires occur regularly with an effort to understand why fires are being lit, and resolve root causes"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={management10}
                            onChange={this.handleCheckChange("management10")}
                            value="management10"
                            id="manageChk10"
                          />
                        }
                        label="10. Actions for rehabilitation of burnt area"
                      />

                      <FormControlLabel
                        control={
                          <div>
                            <Checkbox
                              checked={management11}
                              onChange={this.handleCheckChange("management11")}
                              value="management11"
                              id="manageChk11"
                            />
                            <TextField
                              id="manageChk11Txt"
                              label="Others"
                              placeholder="Others"
                              name="othersmanagementaction"
                              multiline
                              className={classes.textField}
                              margin="normal"
                              variant="outlined"
                              value={othersmanagementaction}
                              onChange={this.handleChange(
                                "othersmanagementaction"
                              )}
                            />
                          </div>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Cause of fire
                </Grid>
                <Grid item>
                  <Typography subtitle1>
                    In this section, please include the causes of the fire that
                    is applicable. Note that the list below is merely a guidance
                    and is non-exhaustive. Members can fill other causes of fire
                    in the last text box.
                  </Typography>
                  <FormControl
                    error={errorCauses}
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes1}
                            onChange={this.handleCheckChange("causes1")}
                            value="causes1"
                            id="causeChk1"
                          />
                        }
                        label="1. Shifting cultivation"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes2}
                            onChange={this.handleCheckChange("causes2")}
                            value="causes2"
                            id="causeChk2"
                          />
                        }
                        label="2. Burning by local communities"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes3}
                            onChange={this.handleCheckChange("causes3")}
                            value="causes3"
                            id="causeChk3"
                          />
                        }
                        label="3. Hunting"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes4}
                            onChange={this.handleCheckChange("causes4")}
                            value="causes4"
                            id="causeChk4"
                          />
                        }
                        label="4. Spread from neighbouring area"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes5}
                            onChange={this.handleCheckChange("causes5")}
                            value="causes5"
                            id="causeChk5"
                          />
                        }
                        label="5. Sabotage"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes6}
                            onChange={this.handleCheckChange("causes6")}
                            value="causes6"
                            id="causeChk6"
                          />
                        }
                        label="6. Arson"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes7}
                            onChange={this.handleCheckChange("causes7")}
                            value="causes7"
                            id="causeChk7"
                          />
                        }
                        label="7. Use of fires as a repellent for wildlife (elephant)"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes8}
                            onChange={this.handleCheckChange("causes8")}
                            value="causes8"
                            id="causeChk8"
                          />
                        }
                        label="8. Encroachment as a temporary measure"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={causes9}
                            onChange={this.handleCheckChange("causes9")}
                            value="causes9"
                            id="causeChk9"
                          />
                        }
                        label="9. Land preparation or new planting"
                      />

                      <FormControlLabel
                        control={
                          <div>
                            <Checkbox
                              checked={causes10}
                              onChange={this.handleCheckChange("causes10")}
                              value="causes10"
                              id="causeChk10"
                            />
                            <TextField
                              id="causeChk10Txt"
                              label="Others"
                              placeholder="Others"
                              name="othercauses"
                              multiline
                              className={classes.textField}
                              margin="normal"
                              variant="outlined"
                              value={otherscauses}
                              onChange={this.handleChange("otherscauses")}
                            />
                          </div>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Any ongoing investigation by
                  <br /> the local authorities on this fire?
                  <br /> If "Yes" please attach the report here.
                </Grid>
                <Grid item xs={9}>
                  <Dropzone
                    onDrop={(acceptedFiles) => this.onFileDrop(acceptedFiles)}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>
                            <b>Click here</b> to upload some documents here
                            (Please select multiple files if required)
                          </p>
                        </div>
                      </section>
                    )}
                  </Dropzone>

                  <GridList cellHeight={320}>
                    <GridListTile
                      key="Subheader"
                      cols={2}
                      style={{ height: "auto", overflow: "auto" }}
                    >
                      <ListSubheader component="div">
                        Upload other documents (non-images) (max: 100MB, format:
                        .pdf | .doc | .docx)
                      </ListSubheader>
                    </GridListTile>

                    {uploadedFile.map((te) => {
                      return (
                        <GridListTile
                          key={uploadedFile.indexOf(te)}
                          style={{ width: 350, height: 80 }}
                        >
                          <GridListTileBar
                            title={te.name}
                            subtitle={
                              <div>
                                <span>
                                  by: {referral} <br />
                                  To download:{" "}
                                  <a
                                    href={
                                      b64FileSources[uploadedFile.indexOf(te)]
                                    }
                                    target="_blank"
                                    download={
                                      blobFileNames !== undefined
                                        ? allBlobsName[
                                            blobFileNames[
                                              uploadedFile.indexOf(te)
                                            ]
                                          ]
                                        : ""
                                    }
                                  >
                                    {blobFileNames !== undefined
                                      ? allBlobsName[
                                          blobFileNames[
                                            uploadedFile.indexOf(te)
                                          ]
                                        ]
                                      : ""}{" "}
                                  </a>
                                </span>
                                <br />
                                <Chip
                                  label="Delete"
                                  onDelete={(e) =>
                                    this.handleDeleteFiles(
                                      uploadedFile.indexOf(te),
                                      blobFileNames[uploadedFile.indexOf(te)]
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        </GridListTile>
                      );
                    })}
                  </GridList>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Remarks
                </Grid>
                <Grid item>
                  <TextField
                    id="remarkTxt"
                    label={this.state.remarks !== "" ? "" : "Remarks"}
                    placeholder="Placeholder"
                    name="remarks"
                    multiline
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    value={this.state.remarks}
                    onChange={this.handleChange("remarks")}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}>
                  Upload images
                </Grid>
                <Grid item xs={9}>
                  <Dropzone
                    onDrop={(acceptedFiles) => this.onImageDrop(acceptedFiles)}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>
                            <b>Click here</b> to upload some images here (Please
                            select multiple images if required)
                          </p>
                        </div>
                      </section>
                    )}
                  </Dropzone>

                  <GridList cellHeight={320} width={850}>
                    <GridListTile
                      key="Subheader"
                      cols={2}
                      style={{ height: "auto", overflow: "auto" }}
                    >
                      <ListSubheader component="div">
                        Images (max: 100MB, format: .jpg | .jpeg | .png | .bmp){" "}
                      </ListSubheader>
                    </GridListTile>

                    {uploadedImages.map((te) => {
                      return (
                        <GridListTile
                          key={uploadedImages.indexOf(te)}
                          style={{ width: 350 }}
                        >
                          <img
                            src={b64Sources[uploadedImages.indexOf(te)]}
                          ></img>
                          <GridListTileBar
                            title={te.name}
                            subtitle={
                              <div>
                                <span>
                                  by: {referral} <br />
                                  To download:{" "}
                                  <a
                                    href={
                                      b64Sources[uploadedImages.indexOf(te)]
                                    }
                                    target="_blank"
                                    download={
                                      blobImagesNames !== undefined
                                        ? allBlobsName[
                                            blobImagesNames[
                                              uploadedImages.indexOf(te)
                                            ]
                                          ]
                                        : ""
                                    }
                                  >
                                    {blobImagesNames !== undefined
                                      ? allBlobsName[
                                          blobImagesNames[
                                            uploadedImages.indexOf(te)
                                          ]
                                        ]
                                      : ""}{" "}
                                  </a>
                                </span>
                                <br />
                                <Chip
                                  icon={<FaceIcon />}
                                  label="Delete"
                                  onDelete={(e) =>
                                    this.handleDelete(
                                      uploadedImages.indexOf(te),
                                      blobImagesNames[
                                        uploadedImages.indexOf(te)
                                      ]
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        </GridListTile>
                      );
                    })}
                  </GridList>
                </Grid>
              </Grid>

              <Grid container style={{ marginLeft: "50px", display: "none" }}>
                <Grid item xs={3}>
                  Month/Year
                </Grid>

                <Grid item style={{ padding: "10px" }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MMM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      value={this.state.monthyear}
                      label="Month/Year"
                      onChange={this.handleDateChange("monthyear")}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>

              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Incidents (Number of fire incidents recorded)
                </Grid>

                <Grid item style={{ padding: "10px" }}>
                  <TextField
                    id="incidence-with-placeholder"
                    name="incidents"
                    label="(If there is no fire incident in any of your concession areas for the month, just state 0)"
                    placeholder="Placeholder"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("incidents")}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item>Activities (Occurences of fires)</Grid>
              </Grid>

              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Weather data: Temperature = ˚C Humidity = % Wind direction =
                  North azimuth degrees Precipitation = mm
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item>
                      <Field
                        id="temp-with-placeholder"
                        label="Celcius"
                        placeholder="Placeholder"
                        name="temperature"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        onChange={this.handleChange("temperature")}
                        component={CustomTextField}
                      />
                    </Grid>
                    <Grid item>
                      <Field
                        id="humid-with-placeholder"
                        label="(%)"
                        placeholder="Placeholder"
                        name="humidity"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        onChange={this.handleChange("humidity")}
                        component={CustomTextField}
                      />
                    </Grid>
                    <Grid item>
                      <Field
                        id="wind-with-placeholder"
                        label="(degrees)"
                        placeholder="Placeholder"
                        name="windDirection"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        onChange={this.handleChange("windDirection")}
                        component={CustomTextField}
                      />
                    </Grid>
                    <Grid item>
                      <Field
                        id="pres-with-placeholder"
                        label="(mm)"
                        placeholder="Placeholder"
                        name="precipitation"
                        className={classes.textField}
                        margin="normal"
                        variant="outlined"
                        onChange={this.handleChange("precipitation")}
                        component={CustomTextField}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Number of injuries/death
                </Grid>
                <Grid item>
                  <Field
                    id="number-with-placeholder"
                    placeholder="Number of injuries/death"
                    name="injuries_"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange("injuries_")}
                    component={CustomTextField}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Estimated losses to the company
                </Grid>
                <Grid item>
                  <FormControl
                    error={errorLoses}
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses1}
                            onChange={this.handleCheckChange("loses1")}
                            value="loses1"
                          />
                        }
                        label="1. Property"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses2}
                            onChange={this.handleCheckChange("loses2")}
                            value="loses2"
                          />
                        }
                        label="2. Personnel"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses3}
                            onChange={this.handleCheckChange("loses3")}
                            value="loses3"
                          />
                        }
                        label="3. Loss of palm tree"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses4}
                            onChange={this.handleCheckChange("loses4")}
                            value="loses4"
                          />
                        }
                        label="4. Reduced cover crop"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses5}
                            onChange={this.handleCheckChange("loses5")}
                            value="loses5"
                          />
                        }
                        label="5. Damage to immature palms that will affect future crop yields"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={loses6}
                            onChange={this.handleCheckChange("loses6")}
                            value="loses6"
                          />
                        }
                        label="6. Indirect impacts on harvest schedules"
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  marginLeft: "50px",
                  display: "none",
                }}
              >
                <Grid item xs={3}>
                  Is this a repeat fire? (Was the area burnt before, areas that
                  are prone to fires)
                </Grid>
                <Grid item>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel component="legend">Repeated Fire</FormLabel>
                    <RadioGroup
                      aria-label="repeatFire"
                      name="repeatFire"
                      className={classes.group}
                      value={this.state.repeatedFire}
                      onChange={this.handleChange("repeatFire")}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio color="primary" />}
                        label="Yes"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio color="primary" />}
                        label="No"
                        labelPlacement="start"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}></Grid>

                <Grid item style={{ padding: "10px" }}>
                  <div className="recaptcha-container">
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      sitekey="6Lde6DwrAAAAAHKvagshtSoyfN-0anoMV30-SxCr"
                      onChange={this.handleCaptchaChange}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "10px", marginLeft: "50px" }}>
                <Grid item xs={3}></Grid>

                <Grid item style={{ padding: "10px" }}>
                  <Button
                    id="submitBtn"
                    variant="contained"
                    disabled={!this.state.isSaveEnabled}
                    color="primary"
                    type="submit"
                  >
                    Save and Upload
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <NotificationSnackBar
              isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
              isSnackbarError={this.state.isSnackbarError}
              snackbarErrorMessage={this.state.snackbarErrorMessage}
            />
            {this.state.loading ? (
              <Grid container className={classes.root}>
                <Grid item xs={12}>
                  <Grid
                    container
                    className={classes.loadingHeight}
                    justify="center"
                    alignItems="center"
                  >
                    <CircularProgress color="primary" size={70} thickness={7} />
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
          </Paper>
        </form>

        <Dialog
          open={checkRequired}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Required Fill"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              There seems to be one or more required fields that is (are) empty.
              <br />
              <p>{checkRequiredMessage}</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ConcessionForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

let SignInWithStyles = withStyles(useStyles)(ConcessionForm);

SignInWithStyles = reduxForm({
  //validate,
  form: "newconcessionFormRed",
  enableReinitialize: true,
})(SignInWithStyles);

function validate(values) {
  const errors = {};
  console.log(values);
  required_fields.forEach(({ name, label }) => {
    if (!values[name]) {
      errors[name] = `You must provide ${label}`;
      // alert(errors[name])
    }
    console.log(errors[name]);
  });

  return errors;
}
//    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      /*officer1:
        state.concessionFormReturn.getForm.officer_names !== undefined &&
        state.concessionFormReturn.getForm.officer_names !== null
          ? state.concessionFormReturn.getForm.officer_names.length > 0
            ? state.concessionFormReturn.getForm.officer_names[0]
            : ""
          : "",*/
      estateName:
        state.concessionFormReturn.getForm.estate_name !== undefined &&
        state.concessionFormReturn.getForm.estate_name !== null
          ? state.concessionFormReturn.getForm.estate_name
          : "",
      certificationStatus:
        state.concessionFormReturn.getForm.area_certified !== undefined &&
        state.concessionFormReturn.getForm.area_certified !== null
          ? state.concessionFormReturn.getForm.area_certified
          : "",
      actualHotspotCoord:
        state.concessionFormReturn.getForm.actual_point !== undefined
          ? state.concessionFormReturn.getForm.actual_point
          : "",
    },
    submitFormRes: state.submitFormRes,
    newConcessionForm: state.concessionFormReturn,
  };
};

export default connect(
  mapStateToProps,

  { fetchAllCompany, fetchNewForm, upload, submitForm }
)(SignInWithStyles);

/*<Paper className={classes.root}>
                        <EnhancedTableToolbar
                            tableName='Search Report' 
                            numSelected={0}
                        />
                        <div className={classes.search} style={{padding:'10px', paddingLeft:'20px'}}>
                            <Grid container spacing={8} alignItems="flex-end">
                                <Grid item>
                                    <SearchIcon />
                                </Grid>
                                <Grid item>
                                <TextField
                                    id="reportID"
                                    label="Report ID / Status"
                                    defaultValue={this.state.reportKeyword}
                                    InputLabelProps={{
                                    shrink: true,
                                    }} 
                                    onChange={this.handleChange('reportKeyword')}
                                />
                                </Grid>
                                <Grid item>
                                    <Button  variant="outlined"
                                    onClick={(e) => this.handleSearch(e) } >Search</Button>
                                </Grid>
                                
                            </Grid>
                        </div>
                        <div className={classes.tableWrapper}>
                            
                        </div>
                </Paper> 
                
                            <ReactUploadFile options={this.options} chooseFileButton={<Button  variant="contained"
                color="primary"  >Choose Files</Button>}  />
                
                <Grid container>
                                
                            <Grid item >
                                    <Field
                                    name="officer2"
                                    id="officer2"
                                    label="Officer 2"
                                    onChange={ this.handleChange('officer2')}
                                    component={CustomTextField}
                                    style={{display:'none'}}
                                />
                                </Grid>
                            </Grid>
                                
                                <Grid item >
                                    <Field
                                    id="officer2Position"
                                    name="officer2Position"
                                    label="Officer 2 Position"
                                    onChange={ this.handleChange('officer2Position')}
                                    component={CustomTextField}
                                    />
                                </Grid>
                <a href='#' download onClick={this.clickToDownload(te,blobFileNames!== undefined ? allBlobsName[blobFileNames[uploadedFile.indexOf(te)]] : '', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')}>{blobFileNames!== undefined ? allBlobsName[blobFileNames[uploadedFile.indexOf(te)]] : ''}</a>
                
                                */

// WEBPACK FOOTER //
// ./src/components/ConcessionForm.js
